// extracted by mini-css-extract-plugin
export default {"infoIcon":"style_infoIcon__2wqG0","infoIconTrigger":"style_infoIconTrigger__rnM0H"};